module.exports = __webpack_public_path__ + "img/peeli.6fca6630.png";